import script from "./SectionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__